import { z } from "zod";
import { INSURANCE_TYPE, DESCRIPTION } from "./consts";

export const schema = z.object({
  [INSURANCE_TYPE]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddFormValues = z.infer<typeof schema>;
